import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cd8d44e8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd8d44e8')) {
      api.createRecord('cd8d44e8', component.options)
    } else {
      api.reload('cd8d44e8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cd8d44e8", function () {
      api.rerender('cd8d44e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/components/FileUpload/index.vue"
export default component.exports